
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}purchase-transactions/`;

export default {
  fetch(params = {}) {
    return axios.get(API_URL, {
      params,
      headers: buildHeaders(),
    });
  },

  show(id) {
    return axios.get(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  },

  review(id, payload) {
    return axios.post(`${API_URL}${id}/review`, payload, {
      headers: buildHeaders(),
    });
  },

  downloadProof(id) {
    return axios.get(`${API_URL}${id}/proof`, {
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  remove(id) {
    return axios.delete(`${API_URL}${id}`, {
      headers: buildHeaders(),
    });
  },

  export(params = {}, format = "excel") {
    return axios.get(`${API_URL}export`, {
      params: { ...params, format },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },
};
